<template>
  <!-- -->
  <div class="banner-show">
      12333333
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.banner-show{
  background: red;
  height: 100px;
}
</style>